import { render, staticRenderFns } from "./FeedbackEntryBox.vue?vue&type=template&id=a1d21fc6&"
import script from "./FeedbackEntryBox.vue?vue&type=script&lang=js&"
export * from "./FeedbackEntryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports